import moment from "moment";
import React, { useEffect, useState } from "react";
import { reduxForm } from "redux-form";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
} from "reactstrap";
import { HUMAN_RESOURCES, ROLE_ADMIN } from "../../../../utility/constants";
import Filters from "../../Utils/Filters/Filters";
import Grid from "../../Utils/Grid";
import { standardActions } from "../../Utils/Grid/StandardActions";
import Title from "../../Utils/Headers/Title";

import "./report-rrhh.css";

const List = (props) => {
    const {
        customUserList,
        setStation,
        station,
        setUser,
        user_,
        setSpecificUser,
        specificUser,
        usersList,
        data,
        loader,
        setStartDate,
        start_date,
        setEndDate,
        end_date,
        me,
        downloadPDF,
        downloadExcel,
        pdfLoading,
        excelLoading,
        getUsers,
    } = props;

    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    const toggleModal = () => setModalOpen(!modalOpen);

    useEffect(() => {
        props.customUserList();
        props.getUsers();
    }, []);

    const handleDataPDF = () => {
        const count = props.data && props.data.count ? props.data.count : 0;
        const message = `El reporte contiene ${count} registros. La generación del PDF puede tardar unos momentos. ¿Desea continuar?`;
        setModalMessage(message);
        setModalOpen(true);
    };

    const confirmDownload = () => {
        props.downloadPDF();
    };

    useEffect(() => {
        if (!pdfLoading && modalOpen) {
            setModalOpen(false);
        }
    }, [pdfLoading]);




    // Minutes to hors (1hrs 0min)
    const converter = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const minutes_ = minutes % 60;
        return `${hours}hrs ${minutes_}min`;
    };

    const columns = [
        {
            dataField: "no_dpi",
            text: "DPI",
        },
        {
            dataField: "first_name",
            text: "Nombre",
            formatter: (cell, row) => `${cell} ${row.last_name}`,
        },
        {
            dataField: "no_registry",
            text: "No. Registro",
        },
        {
            dataField: "station_text",
            text: "Estación Asignada",
        },
        {
            dataField: "job_management",
            text: "Puesto",
            formatter: (cell, row) =>
                row.job_management ? row.job_management : "Sin puesto asignado",
        },
        {
            dataField: "firefighter_type",
            text: "Tipo",
        },
        {
            dataField: "status",
            text: "Estado",
            formatter: (cell, row) => {
                let status = "Sin estado";
                if (row.status === "Activo") {
                    status = "De alta";
                } else if (row.status === "Inactivo")
                    status = `De baja (${row.inactive_reason})`;
                return status;
            },
        },
        {
            dataField: "total_hours_report",
            text: "Horas Totales",
            formatter: (cell) => converter(parseInt(cell, 10) || 0),
        },
        {
            dataField: "id",
            text: "Acciones",
            formatter: (cell, row) =>
                standardActions({
                    ver: "/report/human_resources_report/user",
                    renderVer: (id) => (
                        <a
                            href={`#/report/human_resources_report/user/${id}`}
                            className="btn-action-view"
                            title="Ver"
                        >
                            <span className="material-icons">visibility</span>
                        </a>
                    )
                })(cell, row),
        },
    ];

    let station_ = "";
    station &&
        station.map((station) => {
            station_ += station.name + ', '
        });

    let grandTotal =
        data && data.grand_total !== undefined
            ? data.grand_total
            : (data && data.results && data.results.length > 0
                ? data.results.reduce((acc, row) => acc + (parseInt(row.total_hours_report, 10) || 0), 0)
                : 0);

    const selectedUserName = usersList && specificUser 
        ? usersList.find(u => u.id === parseInt(specificUser))
        : null;
    const userDisplayName = selectedUserName 
        ? `${selectedUserName.first_name} ${selectedUserName.last_name}`
        : "- - - - -";

    const data_ = {
        start_date: start_date
            ? moment(start_date).format("MM-DD-YYYY")
            : "- - - - -",
        end_date: end_date
            ? moment(end_date).format("DD-MM-YYYY")
            : "- - - - -",
        station: station_ ? station_ : "Todas las estaciones",
        user_: user_ === 5 ? 'Activo' : user_ === 1 ? 'Suspendido' : user_ === 2 ? 'Vacaciones' : user_ === 3 ? 'Inactivo' : user_ === 4 ? 'Despedido' : '- - - - -',
        specificUser: userDisplayName,
        grandTotal: converter(grandTotal),
    };

    return (
        <div className="py-4">
            <div className="row">
                <div className="mb-4 col-lg-12">
                    <div className="d-flex justify-content-between align-items-center mb-3 px-2">
                        <div>
                            <h2 className="font-weight-bold" style={{ color: "#1E2A41", fontSize: "1.75rem", margin: 0 }}>Reporte de Recursos Humanos</h2>
                            <h6 className="text-muted" style={{ fontWeight: 500, margin: 0 }}>Listado General</h6>
                        </div>
                        <div className="text-right">
                            <h6 className="font-weight-bold m-0" style={{ color: "#2563eb", fontSize: "0.9rem" }}>Total De Horas/Minutos</h6>
                            <h3 className="font-weight-black m-0" style={{ color: "#1E2A41", fontSize: "1.6rem", letterSpacing: "-0.5px" }}>{converter(grandTotal)}</h3>
                        </div>
                    </div>
                    <div className="mb-4 card card-report-rrhh shadow-sm border-0" style={{ borderRadius: '12px' }}>
                        <div className="mb-4 px-3 pt-3">
                            <div className="filters-container-rrhh m-3">
                                <div className="filters-fields-group">
                                    <Filters
                                        startDate={{
                                            show: true,
                                            start_date: start_date,
                                            setStartDate: setStartDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        endDate={{
                                            show: true,
                                            end_date: end_date,
                                            setEndDate: setEndDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        status_user={{
                                            show: true,
                                            status_user: user_,
                                            setStatusUser: setUser,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "filter_list",
                                        }}
                                        user={{
                                            show: true,
                                            user: specificUser,
                                            setUser: setSpecificUser,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "personSync",
                                        }}
                                        station={{
                                            show:
                                                (props.me.role === ROLE_ADMIN || props.me.role === HUMAN_RESOURCES)
                                                    ? true
                                                    : false,
                                            station:
                                                station,
                                            setStation: setStation,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "business",
                                        }}
                                    />
                                </div>
                                <div className="filters-actions-group">
                                    <button
                                        onClick={downloadExcel}
                                        disabled={!!(start_date && end_date && start_date > end_date) || excelLoading || pdfLoading}
                                        className="btn-bomberos-export btn-bomberos-excel"
                                    >
                                        <span className="material-icons" style={{ fontSize: "18px" }}>
                                            {excelLoading ? 'sync' : 'grid_on'}
                                        </span>
                                        {excelLoading ? 'Exportando...' : 'Excel'}
                                    </button>

                                    <button
                                        onClick={handleDataPDF}
                                        disabled={!!(start_date && end_date && start_date > end_date) || pdfLoading || excelLoading}
                                        className="btn-bomberos-export btn-bomberos-pdf"
                                    >
                                        <span className="material-icons" style={{ fontSize: "18px" }}>
                                            {pdfLoading ? 'sync' : 'picture_as_pdf'}
                                        </span>
                                        {pdfLoading ? "Generando..." : "PDF"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="p-0 px-3 pt-3">
                            <Grid
                                data={data}
                                loading={loader}
                                columns={columns}
                                onPageChange={customUserList}
                                noDataMessage={"Sin Usuarios"}
                                trClassName="table-row-rrhh"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={modalOpen} toggle={toggleModal} centered>
                <ModalHeader toggle={toggleModal} className="border-0">
                    <span className="font-weight-bold" style={{ color: "#1E2A41" }}>Confirmación de Descarga</span>
                </ModalHeader>
                <ModalBody className="text-center py-4">
                    {pdfLoading ? (
                        <div>
                            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                            <h5 className="mt-3 font-weight-bold" style={{ color: "#1E2A41" }}>Generando PDF...</h5>
                            <p className="text-muted">Por favor, espera un momento. El archivo se descargará automáticamente.</p>
                        </div>
                    ) : (
                        <div>
                            <span className="material-icons mb-3" style={{ fontSize: "48px", color: "#2563eb" }}>picture_as_pdf</span>
                            <p className="px-3" style={{ fontSize: "1.1rem", color: "#4b5563" }}>{modalMessage}</p>
                        </div>
                    )}
                </ModalBody>
                {!pdfLoading && (
                    <ModalFooter className="border-0 justify-content-center pb-4">
                        <Button 
                            color="secondary" 
                            onClick={toggleModal} 
                            style={{ borderRadius: '30px', padding: '10px 25px', fontWeight: 'bold' }}
                            outline
                        >
                            Cancelar
                        </Button>
                        <Button 
                            color="primary" 
                            onClick={confirmDownload}
                            style={{ borderRadius: '30px', padding: '10px 25px', backgroundColor: '#2563eb', border: 'none', fontWeight: 'bold' }}
                        >
                            Confirmar Descarga
                        </Button>
                    </ModalFooter>
                )}
            </Modal>
        </div>
    );
};


export default reduxForm({
    form: "ReportHumanResourcesForm",
})(List);
